<template>
  <v-container fluid>
    <TopHeader>
      <template v-slot:title>
        <!-- <div>
          <v-btn
            @click="$router.push({ name: 'Catalog' })"
            color="primary"
            small
            text
          >
            <v-icon left>mdi-keyboard-return</v-icon> Return to catalog
          </v-btn>
        </div> -->
        <span class="text-h5">
          Manage /
          <span
            class="breadcrumb-link"
            @click="$router.push({ name: 'Catalog' })"
            >Catalog</span
          >
          /
          <v-progress-circular
            class="ml-1"
            v-if="loading.product"
            indeterminate
            color="primary"
            :size="22"
          ></v-progress-circular>
          <span class="primary--text" v-else-if="product">{{
            product.name
          }}</span>
          <span class="primary--text" v-else>{{ $route.params.product }}</span>
        </span>
      </template>
      <template v-slot:right>
        <span
          class="subtitle-1 grey--text font-weight-light d-flex"
          style="align-items: flex-end;"
        >
          <v-btn
            class="mr-2"
            v-if="(isEditingProposal || editMode) && !$store.getters.isViewer"
            :disabled="
              loading.submit ||
                loading.proposal ||
                loading.product ||
                loading.cancelling
            "
            @click="cancelEditProposal"
            color="grey"
            text
          >
            Cancel
          </v-btn>
          <v-btn
            @click="submitValidate"
            v-if="!isValidated && $store.getters.isBrandUser"
            color="primary"
            :loading="loading.submit"
            :disabled="
              loading.submit || loading.proposal || loading.product || !product
            "
          >
            <v-icon left>mdi-alert-circle-check-outline</v-icon>
            {{
                isEditingProposal ?
                  isCreateRequest ?
                    "validate & request creation"
                    : "validate & request edit"
                  : "validate"
            }}
          </v-btn>
          <v-btn
            v-else-if="
              $store.getters.isUserAdmin ||
                $store.getters.isBrandUser ||
                $store.getters.isContributor
            "
            @click="submitProposal(false)"
            color="primary"
            :loading="loading.submit"
            :disabled="
              !hasChanged ||
                loading.submit ||
                loading.proposal ||
                loading.product ||
                loading.updating
            "
          >
            <template> <v-icon left>mdi-check</v-icon>submit update</template>
          </v-btn>
          
          <v-dialog
              v-model="dialogTransfer"
              width="500"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="$store.getters.isUserAdmin"
                  class="ml-2"
                  color="warning"
                  v-bind="attrs"
                  v-on="on"
                  :loading="loading.transfer"
                  :disabled="     
                      loading.transfer
                  "
                >
                  <template> <v-icon left>mdi-forward</v-icon>Transfer</template>
                </v-btn>
              </template>

              <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                  Product Transfer
                </v-card-title>

                <v-card-text class="mt-5">
                  Choose Brand
                  <v-select
                    :items="$store.state.brands"
                    class="mt-2"  
                    label="All brands"
                    item-text="name"
                    item-value="brand_id"
                    v-model="transferBrandId"
                    outlined
                  ></v-select>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="grey"
                    text
                    @click="dialogTransfer=false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="submitTransfer()"
                  >
                    Transfer
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
         
        </span>
      </template>
    </TopHeader>
    <PlaceholderWrapper
      class="mt-10"
      :is-empty="product === null"
      :is-loading="loading.proposal || loading.product"
      empty-message="We didn't find the product you requested"
    >
      <template v-slot:content>
        <div>
          <ValidationControls
            @validate="handleValidate"
            @reject="handleRejection"
            :proposal="proposal"
            v-if="hasPendingProposal && $store.getters.isUserAdmin"
          />
          <v-row class="mt-2">
            <v-col cols="6" v-if="isValidated || hasPendingProposal">
              <div class="text-center primary--text text-h6 mb-6">
                Current
              </div>
              <Product
                :tab-index="tab"
                :lang-tab-index="langTab"
                v-model="product"
                read-only
                @onTabChange="t => (tab = t)"
                @onLangTabChange="t => (langTab = t)"
              />
            </v-col>
            <v-col :cols="isValidated || hasPendingProposal ? 6 : 12">
              <div
                class="text-center text-h6 accent--text mb-6"
                v-if="isValidated || hasPendingProposal"
              >
                Proposal
              </div>

              <ProposalStaging
                @edit="v => (editMode = v)"
                :cancelEditCounter="cancelEditCounter"
                @cancel="handleCancel"
                :loading="
                  loading.proposal ||
                    loading.product ||
                    loading.cancelling ||
                    loading.updating
                "
                :last-proposal="proposal"
                :validation-stage="!isValidated && !isCreateRequest"
              >
                <template v-slot>
                  <div class="mt-0 pt-0 px-0">
                    <Product
                      @addLocale="handleAddLocale"
                      :tab-index="tab"
                      :rules="rules"
                      :lang-tab-index="langTab"
                      v-model="productProposal"
                      :read-only="$store.getters.isViewer"
                      :valueRef="productReference"
                      @onTabChange="t => (tab = t)"
                      @onLangTabChange="t => (langTab = t)"
                      :differences="differences"
                    />
                  </div>
                </template>
              </ProposalStaging>
            </v-col>
          </v-row>
        </div>
      </template>
    </PlaceholderWrapper>
  </v-container>
</template>

<script>
import { ValidationControls } from "@/components"
import PlaceholderWrapper from "@/components/base/PlaceholderWrapper"
import TopHeader from "@/components/base/TopHeader.vue"
import Product from "@/components/perfumist/product/Product"
import ProposalStaging from "@/components/perfumist/ProposalStaging.vue"
import { PROPOSAL_STATUS } from "@/data"
import { ProductService } from "@/services"
import { required } from "@/utils/validator"
import _ from "lodash"
import moment from "moment"
export default {
  components: {
    PlaceholderWrapper,
    Product,
    ProposalStaging,
    TopHeader,
    ValidationControls,
  },
  data() {
    return {
      loading: {
        cancelling: false,
        updating: false,
        proposal: true,
        product: true,
        submit: false,
        transfer: false
      },
      dialogTransfer: false,
      transferBrandId: 10,
      langTab: "tab-en",
      tab: 0,
      proposal: null,
      productProposal: null,
      productProposalReference: null,
      product: null,
      productReference: null,
      cancelEditCounter: 0,
      editMode: false,
      differences: {
        descriptionTab: false,
        imagesTab: false,
        attributesTab: false,
        locales: {
          en: {
            name: false,
            description: false
          }
        },

        category: false,
        product_type: false,
        price: false,
        discontinued: false,
        gender: false,
        launched_at: false,
        year: false,
        discontinued_at: false,
        product_families: {
          families: false,
          sub_families: false
        },
        product_notes: {
          top: false,
          base: false,
          middle: false
        },
        images: {
          main: false,
          bottle: false,
          package: false
        }
      }
    }
  },
  computed: {
    rules() {
      const discontinuedAtRules =
        this.productProposal.data.discontinued === 1 ? [required] : null

      if (this.$store.getters.isUserAdmin) {
        return {
          brand_input: [required],
          product_type: null,
          gender: null,
          price: null,
          year: null,
          category: null,
          
          // Extrafields
          product_perfume_houses: null,
          product_perfumers: null,
          product_ingredients: null,
          product_distribution: null,
          
          product_families: {
            families: null,
            sub_families: null
          },
          product_notes: {
            top: null,
            base: null,
            middle: null
          },
          launched_at: null,
          discontinued_at: discontinuedAtRules,
          discontinued: null,
          images: { main: [required], bottle: null, package: null },
          locales: { en: { name: [required], description: null } }
        }
      }

      // normal user rules
      return {
        brand_input: [required],
        product_type: [required],
        gender: [required],
        price: null,
        year: [required],
        category: [required],

        // Extrafields
        product_perfume_houses: null,
        product_perfumers: null,
        product_ingredients: null,
        product_distribution: null,

        product_families: {
          families: [required],
          sub_families: [required]
        },
        product_notes: {
          top: [required],
          base: [required],
          middle: [required]
        },
        launched_at: null,
        discontinued_at: discontinuedAtRules,
        discontinued: [required],
        images: { main: [required], bottle: null, package: null },
        locales: { en: { name: [required], description: [required] } }
      }
    },
    hasChanged() {
      let toPick = ["data"]
      if (this.product == null) {
        return false
      }
      return (
        !_.isEqual(
          _.pick(this.productProposal, toPick),
          _.pick(this.product, toPick)
        ) && (this.propposal !== null ? this.isEditingProposal : true)
      )
    },
    isApproved() {
      if (this.proposal !== null) return this.proposal.approved
      return true
    },
    isEditingProposal() {
      if (
        this.productProposalReference == null ||
        this.productProposal == null ||
        this.proposal == null
      )
        return false

      return !_.isEqual(this.productProposal, this.productProposalReference) //&& this.productId
    },
    hasPendingProposal() {
      return this.proposal?.pending_request !== null
    },
    // hasVerifiedProposal() {
    //   return this.proposal?.id !== null && !!this.proposal?.verified_at
    // },
    // hasPendingProposal() {
    //   return (
    //     (this.proposal?.id !== null && !this.proposal?.pending_request) ||
    //     !this.productId
    //   )
    // },
    hasPendingCreateRequest() {
      return (
        this.proposal?.product_id == null &&
        this.proposal?.status === PROPOSAL_STATUS.CREATE_REQUEST
      )
    },
    isValidated() {
      if (this.product && this.product.validated) return true
      return false
    },
    productId() {
      return this.$route.params.product
    },
    isCreateRequest() {
      return !this.proposal?.product_id
    }
  },
  mounted() {
    this.getProduct()
  },
  methods: {
    moment,
    clearLoadings() {
      for (let attr in this.loading) this.loading[attr] = false
    },
    handleAddLocale(locale) {
      this.product.data.locales.push(locale)
      this.$nextTick(() => {
        this.langTab = "tab-" + locale.code.toLowerCase()
      })
    },
    cancelEditProposal() {
      this.cancelEditCounter = this.cancelEditCounter + 1
      this.productProposal = _.cloneDeep(this.productProposalReference)
      this.product = _.cloneDeep(this.productReference)
    },
    patchProduct() {},
    getProduct() {
      this.loading.product = true
      this.loading.proposal = true
      ProductService.get(this, this.$route.params.product)
        .then(result => {
          const product = result
          const proposal = {}

          this.product = product

          if (result) {
            if (
              product.pending_request &&
              product.status !== PROPOSAL_STATUS.DELETE_REQUEST &&
              product.status !== PROPOSAL_STATUS.DISCONTINUATE_REQUEST
            ) {
              this.proposal = product.pending_request
              // Patch product proposal to add Image on Root
              this.proposal["data"] = this.proposal["data_approved"]
              this.proposal["validated"] = this.product["validated"]
              this.proposal["status"] = this.product["status"]
              this.proposal["pending_request"] = this.product["pending_request"]
            } else {
              this.proposal = product
            }
            // Patch images

            this.productProposal = _.cloneDeep(this.proposal)

            this.productProposalReference = _.cloneDeep(this.proposal)

            this.productReference = _.cloneDeep(product)

            let codeLocalesdifferences = this.productProposalReference.data_approved.locales.filter(
              x => this.product.data.locales.every(x2 => x2.code !== x.code)
            )
            codeLocalesdifferences.forEach(element => {
              this.product.data.locales.push(element)
            })

            this.checkAllDifferences()
          }
          this.editMode = false
          this.cancelEditCounter = this.cancelEditCounter + 1
        })
        .finally(() => {
          this.clearLoadings()
          this.langTab = "tab-en"
          this.tab = 0
        })
    },

    checkAllDifferences() {
      const multipleAttributes = ["product_families", "product_notes", "images"]

      this.getSimpleAttributesDifferences(
        this.product.data,
        this.productProposal.data_approved
      )

      multipleAttributes.forEach(el => {
        this.getMultipleAttributesDifferences(
          this.productProposal.data_approved,
          this.product.data,
          el
        )
      })

      this.getLocalesDifferences(
        this.productProposal.data_approved.locales,
        this.product.data.locales
      )
    },

    getSimpleAttributesDifferences(obj1, obj2) {
      const changes = _.differenceWith(
        _.toPairs(obj2),
        _.toPairs(obj1),
        _.isEqual
      )

      Object.keys(_.fromPairs(changes)).forEach(e => {
        if (typeof this.differences[e] == "boolean") {
          if (_.hasIn(this.differences, e)) {
            this.differences.attributesTab = true
            this.differences[e] = true
          }
        }
      })
    },

    getMultipleAttributesDifferences(obj1, obj2, attribute) {
      Object.keys(obj1[attribute]).forEach(key => {
        if (!_.isEqual(obj1[attribute][key], obj2[attribute][key])) {
          this.differences[attribute][key] = true
        }
      })
      if (this.differences.images == true) {
        this.differences.imagesTab = true
      } else if (
        this.differences.product_families == true ||
        this.differences.product_notes == true
      ) {
        this.differences.attributesTab = true
      }
    },

    getLocalesDifferences(obj1, obj2) {
      obj1.forEach(a => {
        obj2.forEach(b => {
          if (a.code == b.code) {
            this.differences.locales[a.code] = {
              name: !_.isEqual(a.data.name, b.data.name),
              description: !_.isEqual(a.data.description, b.data.description)
            }

            if (
              !_.isEqual(a.data.name, b.data.name) ||
              !_.isEqual(a.data.description, b.data.description)
            ) {
              this.differences.descriptionTab = true
            }
          }
        })
      })
    },

    handleCancel() {
      let message = "Are you sure you want to cancel this request ?"
      if (this.isCreateRequest) {
        message += " Cancelling this request will delete the item for good."
      }

      if (confirm(message)) {
        this.loading.submit = true
        this.loading.cancelling = true
        ProductService.cancel(this, this.product.id)
          .then(async r => {
            this.$router.push({ name: "Catalog" })
          })
          .finally(() => {
            this.loading.submit = false
            this.loading.cancelling = false
          })
      }
    },

    submitProposal(skipConfirm = false) {
      if (
        skipConfirm ||
        confirm(
          `Are you sure you want to send this proposal? ${
            this.$store.getters.isUserAdmin
              ? "(As an admin, this request is approved automatically)"
              : ""
          }`
        )
      ) {
        if (!this.hasPendingProposal || this.isApproved) {
          this.loading.submit = false
          ProductService.create(
            this,
            {
              data_approved: this.productProposal.data,
              status: this.isCreateRequest
                ? PROPOSAL_STATUS.CREATE_REQUEST
                : PROPOSAL_STATUS.EDIT_REQUEST
            },
            this.productId
          )
            .then(r => {
              this.getProduct()
            })
            .finally(() => {
              this.loading.submit = false
            })
        } else {
          ProductService.editRequest
            .update(this, this.product.id, {
              data_approved: this.productProposal.data
            })
            .then(r => {
              this.$router.push({ name: "Catalog" })
            })
            .finally(() => {
              this.loading.submit = false
            })
          // TODO
          // DatasetService.update(
          //   this,
          //   this.$HMD.constants.PRODUCT_EDIT_HISTORY_DATASET_UID,
          //   {
          //     ...this.proposal,
          //     product_id: this.productId,
          //     data: this.productProposal.data,
          //     data_approved: this.productProposal.data,
          //     updated_at: new Date(),
          //     brand_id: 998,
          //     approved: this.$store.getters.isUserAdmin,
          //     verified_attached_message: null,
          //     verified_by_id: null,
          //     verified_at: null
          //   },
          //   [{ name: "id", primary_key: true }]
          // )
          //   .then(() => {
          //     this.$router.push({ name: "Catalog" })
          //   })
          //   .finally(() => {
          //     this.loading.submit = false
          //   })
          // } else {
          // alert("toto")
          // TODO
          // DatasetService.update(
          //   this,
          //   this.$HMD.constants.PRODUCT_EDIT_HISTORY_DATASET_UID,
          //   {
          //     ...this.proposal,
          //     product_id: this.productId,
          //     data_approved: this.productProposal.data,
          //     data: this.productProposal.data,
          //     approved: this.$store.getters.isUserAdmin,
          //     verified_attached_message: null,
          //     verified_by_id: null,
          //     updated_at: new Date()
          //   },
          //   [{ name: "id", primary_key: true }]
          // )
          //   .then(async r => {
          //     if (
          //       this.proposal.status === CONSTS.PROPOSAL_STATUS.CREATE_REQUEST
          //     ) {
          //       // if created_request => delete product_created
          //       const TO_EXCLUDE = [
          //         "product_data.",
          //         "last_edit_request.",
          //         "image.",
          //         "brand.",
          //         "additional_data"
          //       ]
          //       const p = Object.keys(this.product)
          //         .filter(k => !TO_EXCLUDE.find(attr => k.indexOf(attr) >= 0))
          //         .reduce(
          //           (prev, curr) => ({ ...prev, [curr]: this.product[curr] }),
          //           {}
          //         )
          //     }
          //     this.getProduct()
          //     this.$store.commit("success", "Proposal request updated !")
          //   })
          //   .finally(() => {
          //     this.loading.submit = false
          //   })
          // }
        }
      }
    },
    submitValidate() {
      if (confirm("Are you sure that you want to validate this product ?")) {
        this.loading.submit = true

        if (this.isEditingProposal) {
          this.submitProposal(true)
        } else {
          ProductService.validate(this, this.productId)
            .then(async r => {
              this.getProduct()
              this.$store.commit("success", "Product validated")
              this.$router.push({ name: "Catalog" })
              // if modificated are made => make edit request
              // if (this.isEditingProposal) {
              //   this.submitProposal()
              // } else this.getProduct()
            })
            .finally(() => {
              this.loading.submit = false
            })
        }
      }
    },
    submitTransfer() {
      this.loading.transfer = true
      ProductService.transfer(this, this.productId, this.transferBrandId)
          .then(r => {
            // this.getProduct()
            
            this.$store.commit("success", "Product transferred")
            this.$router.push({ name: "Catalog" })
          })
          .finally(() => {
            this.dialogTransfer = false
            this.loading.transfer = false
          })
    },
    //  Admin methods
    handleValidate() {
      if (this.hasPendingProposal)
        ProductService.editRequest
          .approve(this, this.productId || this.product.id, this.proposal)
          .then(r => {
            this.getProduct()
            this.$store.commit("success", "Request validated")
            this.$router.push({ name: "Catalog" })
          })
    },
    handleRejection(msg) {
      if (this.hasPendingProposal)
        ProductService.editRequest
          .reject(this, this.productId || this.product.id, msg)
          .then(r => {
            this.getProduct()
            this.$store.commit("success", "Request rejected")
          })
    }
  }
}
</script>

<style lang="scss">
.product-slider {
  .v-tabs-slider,
  .v-tab {
    border-top-left-radius: 10px !important;
    border-top-right-radius: 10px !important;
  }
  .v-tabs-slider-wrapper {
    z-index: 0 !important;
    height: 100% !important;
  }
  .v-tab--active {
    color: white !important;
  }
}
</style>
